import { render, staticRenderFns } from "./UnsetBondPolMOM.vue?vue&type=template&id=920fb2e2&"
import script from "./UnsetBondPolMOM.vue?vue&type=script&lang=js&"
export * from "./UnsetBondPolMOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports